import { Breadcrumb } from "antd";
import { useIntl } from "react-intl";
import { useLocation } from "react-router-dom"; // Import the necessary dependencies
import QuickActionButton from "../../components/common/QuickActionButton";
// import QuickActionLayout from "../../components/common/QuickActionLayout";
import useBreadcrumb from "../../hooks/useBreadcrumb";
type Props = {};

const HeaderSettings = (props: Props) => {
  const location = useLocation(); // Get the current location using useLocation hook
  const intl = useIntl();
  const bread = useBreadcrumb();
  // Function to render title based on the current route
  const renderBreadcrumb: any = () => {
    const getPathItems = () => {
      if (location.pathname === "/settings") {
        return [
          {
            title: (
              <>
                <div className="text-2xl font-semibold text-color-primary">
                  {intl.formatMessage({ id: "settings_title" })}
                </div>
                <div className="my-4 text-base font-normal leading-7 text-color-gray">
                  {intl.formatMessage({ id: "settings_description" })}
                </div>
              </>
            ),
          },
        ];
      }
    };

    const breadcrumbItems = getPathItems();

    return location.pathname === "/settings" ? (
      <Breadcrumb separator=">" items={breadcrumbItems} />
    ) : (
      bread
    );
  };

  return (
    <>
      <div className="flex justify-between w-full mb-6">
        <div className="w-full">{renderBreadcrumb()}</div>
        <QuickActionButton />
      </div>
    </>
  );
};

export default HeaderSettings;
